import * as React from 'react'
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Link,
  SvgIcon,
  useTheme
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import PostAddIcon from '@mui/icons-material/PostAdd';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import RedeemIcon from '@mui/icons-material/Redeem';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout'

import routes from '../../routes'
import useStyles from './styles'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation, withTranslation } from 'react-i18next'
import { useApolloClient, gql, useMutation } from '@apollo/client'
import { workerlogout, adminlogout } from '../../apollo'

const LOGOUT_ADMIN = gql`${adminlogout}`
const LOGOUT_WORKER = gql`${workerlogout}`

const drawerWidth = 240

const CentralAdminSidebar = (props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const location = useLocation()
  const classes = useStyles()
  const { window } = props

  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [openGroups, setOpenGroups] = React.useState({
    reports: false,
    nestpass: false,
    promotions: false,
    landing: false,
    inventory: false,
  })

  const toggleGroup = (group) => {
    setOpenGroups(prev => ({ ...prev, [group]: !prev[group] }))
  }

  const userType = JSON.parse(localStorage.getItem('user-native'))
  const userRole = localStorage.getItem('userRole')
  const client = useApolloClient()
  const history = useHistory()

  const [adminLogoutMutation] = useMutation(LOGOUT_ADMIN)
  const [workerLogoutMutation] = useMutation(LOGOUT_WORKER)

  const logout = async () => {
    let logoutResponse
    if (userRole === 'Admin') {
      if (userType.userType === 0 || userType.userType === 1 || userType.userType === 2) {
        logoutResponse = await adminLogoutMutation()
      } else {
        logoutResponse = await workerLogoutMutation()
      }
    } else if (userType.workerType === 0 || userType.workerType === 1 || userType.workerType === 2) {
      logoutResponse = await workerLogoutMutation()
    } else {
      logoutResponse = await workerLogoutMutation()
    }

    if (logoutResponse.data.logoutAdmin || logoutResponse.data.logoutWorker) {
      localStorage.removeItem('user-native')
      localStorage.removeItem('restaurant_id')
      client.clearStore()

      const cookies = document.cookie.split(';')
      cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
      })

      history.push('/auth/login')
    }
  }

  React.useEffect(() => {
    // Auto-open groups based on URL
    if (
      location.pathname.includes('orderstats') ||
      location.pathname.includes('datewise') ||
      location.pathname.includes('orderstatus') ||
      location.pathname.includes('weekly-sales-by-category')
    ) {
      setOpenGroups(prev => ({ ...prev, reports: true }))
    }
    if (location.pathname.includes('nestPassdashboard') || location.pathname.includes('managenestpass') || location.pathname.includes('upgradeToNestPass')) {
      setOpenGroups(prev => ({ ...prev, nestpass: true }))
    }
    // You can add auto-open for other groups if needed
  }, [location.pathname])

  const container = window !== undefined ? () => window().document.body : undefined

  const createLinks = (
    <Box className={classes.sidebarBox}>
      <Toolbar className={[classes.rowDisplay, classes.logo]}>
        <img alt="logo" src="https://cdn.nativenest.in/pro/logo/Native-Nest-Logo.jpg" style={{ height: '50px', width: '50px' }} />
        <Typography variant="h2" className={classes.logoText}>
          NativeNest <br /> Central Admin
        </Typography>
      </Toolbar>

      <Box className={classes.sidebarList}>
        {/* NORMAL MENU ITEMS */}
        {routes.filter(r => r.appearInSidebar && r.centralAdmin && !r.group).map((prop) => (
          <Link
            key={prop.path}
            className={[classes.rowDisplay, classes.sidebarLink, location.pathname === prop.layout + prop.path && classes.active]}
            href={'#' + prop.layout + prop.path}
            underline="none"
          >
            <SvgIcon component={prop.icon} fontSize="small" />
            <Typography variant="h6" className={[classes.linkText, location.pathname !== prop.layout + prop.path ? classes.blackText : classes.blueText]}>
              {t(prop.name)}
            </Typography>
          </Link>
        ))}

        {/* COLLAPSIBLE GROUPS */}
        {[
          { key: 'management', label: 'Management', icon: AdminPanelSettingsIcon },
          { key: 'reports', label: 'Reports', icon: PostAddIcon },
          { key: 'nestpass', label: 'NestPass', icon: CardMembershipIcon },
          { key: 'promotions', label: 'Promotions', icon: RedeemIcon },
          { key: 'landing', label: 'Landing / Display', icon: DisplaySettingsIcon},
          { key: 'inventory', label: 'Inventory & Tax', icon: Inventory2Icon },
          { key: 'systemsetting', label: 'System Setting', icon: SettingsIcon },
        ].map(group => (
          <React.Fragment key={group.key}>
            {/* PARENT LINK */}
            <Link
              onClick={(e) => { e.preventDefault(); toggleGroup(group.key) }}
              className={[classes.rowDisplay, classes.sidebarLink, classes.parentMenu]}
              underline="none"
            >
              <SvgIcon component={group.icon} fontSize="small" />
              <Typography variant="h6" className={classes.linkText}>
                {t(group.label)}
              </Typography>
              {openGroups[group.key] ? <ExpandLessIcon className={classes.arrowIcon} /> : <ExpandMoreIcon className={classes.arrowIcon} />}
            </Link>

            {/* CHILD LINKS */}
            {openGroups[group.key] && (
              <Box className={classes.subMenu}>
                {routes.filter(r => r.group === group.key && r.appearInSidebar && r.centralAdmin).map((prop) => (
                  <Link
                    key={prop.path}
                    className={[classes.rowDisplay, classes.subMenuLink, location.pathname === prop.layout + prop.path && classes.active]}
                    href={'#' + prop.layout + prop.path}
                    underline="none"
                  >
                    <SvgIcon component={prop.icon} fontSize="small" />
                    <Typography
                      variant="h6"
                      className={[classes.linkText, location.pathname !== prop.layout + prop.path ? classes.blackText : classes.blueText]}
                    >
                      {t(prop.name)}
                    </Typography>
                  </Link>
                ))}
              </Box>
            )}
          </React.Fragment>
        ))}

        {/* LOGOUT */}
        <Link onClick={(e) => { e.preventDefault(); logout() }} className={[classes.rowDisplay, classes.sidebarLink]} underline="none">
          <SvgIcon component={LogoutIcon} fontSize="small" />
          <Typography variant="h6" className={classes.linkText}>
            Logout
          </Typography>
        </Link>
      </Box>
    </Box>
  )

  return (
    <>
      <AppBar position="fixed" sx={{ width: { sm: `calc(100% - ${drawerWidth}px)` }, ml: { sm: `${drawerWidth}px` }, display: { sm: 'none' } }}>
        <Toolbar>
          <IconButton onClick={() => setMobileOpen(!mobileOpen)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box component="nav">
        <Drawer container={container} variant="temporary" open={mobileOpen} onClose={() => setMobileOpen(false)} sx={{ display: { xs: 'block', sm: 'none' } }}>
          {createLinks}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              background: `linear-gradient(180deg, ${theme.palette.warning.dark} 50%, transparent 50%)`,
              borderRight: 'none'
            }
          }}
          open
        >
          {createLinks}
        </Drawer>
      </Box>
    </>
  )
}

export default withTranslation()(CentralAdminSidebar)
